export enum ActionEventsEnum {
  SEARCH = 'search',
  FILTER = 'filter',
  CLICK = 'click',
  CHANGE = 'change',
  VIEW = 'view',
  ORDER = 'order',
  VIDEO_PLAYED = 'Video Played',
  USER_CLICKED = 'User Clicked',
  VIDEO_WATCHED = 'Video Watched',
  LOADED_A_ELEMENT = 'Loaded a Element',
  ELEMENT_LOADED = 'Element Loaded',
  LOADED_A_PAGE = 'Loaded a Page',
  UNKNOWN = 'Unknown',
  MODAL_OPENED = 'Modal Opened',
  MODAL_CLOSED = 'Modal Closed',
  ELEMENT_CLICKED = 'Element Clicked',
  PAGE_LOADED = 'Page Loaded',
  FIELD_ERROR_DISPLAYED = 'Field Error Displayed',
  REGISTER_UPDATED = 'Register Updated'
}
